// Seniority rosters — the work locations a claimant holds seniority ACROSS, one level
// below the Local Committee (per the 2026-08-02 decision of record: a Local can span
// multiple rosters). A yardmaster is mobile within his roster, so an incident can occur
// at any location in it — the incident-location picker is limited to these.
//
// Source: GC Bob Keeley (SME). Hand-authored; a location not in any roster falls back to
// free-text entry so nothing is ever blocked. Add rosters as Bob defines them.
export const SENIORITY_ROSTERS = {
  // Amtrak NYC roster (within LC1951-342C). Confirmed by Bob 2026-08-05.
  'Amtrak-NYC': [
    'NY-PSCC (Penn Station Central Control)',
    'SSY-West End (Sunnyside Yard — West End)',
    'SSY-East End (Sunnyside Yard — East End)',
  ],
};

// The roster location list a work location belongs to, or null if none is defined for it.
export function rosterLocationsFor(workLocation) {
  if (!workLocation) return null;
  for (const locs of Object.values(SENIORITY_ROSTERS)) {
    if (locs.includes(workLocation)) return locs;
  }
  return null;
}
